export default __webpack_public_path__ + "static/media/Textura_nuestroequipo.1f8e1a2d.svg";